import { useCallback } from 'react';
import { notification } from 'components';
import { useRoleDeleteMutation } from 'api';
import { ErrorMappingValueType } from 'typings';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({
        message: message,
      });
    },
    [notificationApi]
  );

  const [roleDelete, { isLoading }] = useRoleDeleteMutation();
  const handleErrors = useCallback(
    (error: any) => {
      if (!error?.data?.success && error?.data?.data) {
        Object.values(error.data.data).forEach((message) => {
          openNotificationWithIcon({
            type: 'error',
            message: message as string,
          });
        });
      } else {
        openNotificationWithIcon({
          type: 'error',
          message: 'Something went wrong!',
        });
      }
    },
    [openNotificationWithIcon]
  );

  const onRemoveConfirm = useCallback(
    async (role: Record<string, any> | undefined) => {
      if (role) {
        try {
          const response = await roleDelete({
            ...role,
          });
          if (response?.data?.success) {
            openNotificationWithIcon({
              type: 'success',
              message: 'Role was successfully deleted.',
            });
            onDeleteModalClose();
          } else {
            handleErrors(response.error);
          }
        } catch (err) {
          handleErrors(err);
        }
      }
    },
    [roleDelete, openNotificationWithIcon, onDeleteModalClose, handleErrors]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
